var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.init)?_c('initial-loading'):_c('div',{class:{'full': _vm.fullscrean}},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]),(_vm.text)?_c('div',{staticClass:"small text-muted font-weight-bold mb-4"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }